// @flow

import * as React from "react";
import _ from "lodash";

type PropsType = {
    classes: any,
    inputElement: any,
    showErrors: boolean,
    errors: ?Array<any>,
    id: string,
    label: string,
    name: string,
    required: ?boolean,
    fileValidations: {
        maxSizePretty?: string,
        maxSizeBytes?: Array<number>,
        allowedExtensions?: Array<string>,
    },
};

type StateType = {
    fileName: string,
    files: ?FileList,
    error: ?string,
};

class FileUploadField extends React.Component<PropsType, StateType> {
    state = {
        fileName: "",
        files: null,
        error: null,
    };

    input = React.createRef<HTMLInputElement>();

    handleButtonClick = (event: SyntheticEvent<HTMLButtonElement>) => {
        if (this.input.current) {
            this.input.current.click();
        }
    };

    handleInputChange = (event: SyntheticEvent<HTMLInputElement>) => {
        const { target } = event;
        if (target instanceof HTMLInputElement) {
            this.setState(
                {
                    fileName: target.value.split("\\").pop(),
                    files: target.files,
                },
                this.validate
            );
        }
    };

    validate = (): { error: string, label: string } => {
        const { maxSizeBytes, allowedExtensions } = this.props.fileValidations;

        // Check required
        if (this.props.required) {
            if (this.state.fileName === "") {
                const error = "This field is required";
                this.setState({
                    error,
                });
                return { error, label: this.props.label };
            }
        }

        // Check filesize
        if (
            this.state.files &&
            this.state.files.length > 0 &&
            maxSizeBytes &&
            maxSizeBytes[0]
        ) {
            const { files } = this.state;
            if (files && files.length) {
                const [file: File] = files;
                if (file.size > maxSizeBytes[0]) {
                    const error = "Exceeds maximum file size";
                    this.setState({
                        error,
                    });
                    return {
                        error,
                        label: this.props.label,
                    };
                }
            }
        }

        // Check filetype
        if (allowedExtensions && allowedExtensions.length > 0) {
            const { files } = this.state;
            if (files && files.length) {
                const [file: File] = files;
                const fileExtension = file.name
                    .split(".")
                    .pop()
                    .toUpperCase();

                let hasValidExtension = false;
                allowedExtensions.map(_.toUpper).forEach((ext: string) => {
                    if (fileExtension === ext) {
                        hasValidExtension = true;
                    }
                });
                if (!hasValidExtension) {
                    const error = "That file extension is not supported";
                    this.setState({ error });
                    return {
                        error,
                        label: this.props.label,
                    };
                }
            }
        }

        this.setState({ error: null });
        return {
            error: "",
            label: this.props.label,
        };
    };

    render(): React.Node {
        const fileSizeString = this.props.fileValidations.maxSizePretty
            ? `${this.props.fileValidations.maxSizePretty}MB limit. `
            : "";

        const { allowedExtensions } = this.props.fileValidations;
        let allowedFormatsString = "";
        if (allowedExtensions) {
            allowedFormatsString = allowedExtensions.map(_.toUpper).join(", ");
        }

        return (
            <div
                className={`file-upload-field file-upload-field--${
                    this.state.error ? "invalid" : "valid"
                }`}
            >
                <input
                    type="file"
                    id={this.props.name}
                    name={this.props.name}
                    ref={this.input}
                    onChange={this.handleInputChange}
                />
                <label
                    className="file-upload-field__label"
                    htmlFor={this.props.name}
                >
                    {this.props.label}
                </label>
                <div className="file-upload-field__wrap">
                    <div className="file-upload-field__input-display">
                        {this.state.fileName || "No file selected"}
                    </div>
                    <button
                        type="button"
                        onClick={this.handleButtonClick}
                        className="file-upload-field__button button button--ghost button--inline button--no-shadow"
                    >
                        Choose file...
                    </button>
                </div>
                {this.state.error ? (
                    <div className="file-upload-field__error">
                        {this.state.error}
                    </div>
                ) : null}
                <div className="file-upload-field__message">
                    {`One file only. ${fileSizeString}Allowed format: ${allowedFormatsString}`}
                </div>
            </div>
        );
    }
}

export default FileUploadField;
